var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00039 2.60039C5.01805 2.60039 2.60039 5.01805 2.60039 8.00039C2.60039 10.9827 5.01805 13.4004 8.00039 13.4004C10.9827 13.4004 13.4004 10.9827 13.4004 8.00039C13.4004 7.66902 13.669 7.40039 14.0004 7.40039C14.3318 7.40039 14.6004 7.66902 14.6004 8.00039C14.6004 11.6455 11.6455 14.6004 8.00039 14.6004C4.35531 14.6004 1.40039 11.6455 1.40039 8.00039C1.40039 4.35531 4.35531 1.40039 8.00039 1.40039C9.78823 1.40039 11.4096 2.11143 12.5977 3.26502V2.00039C12.5977 1.66902 12.8663 1.40039 13.1977 1.40039C13.5291 1.40039 13.7977 1.66902 13.7977 2.00039V5.00039C13.7977 5.33176 13.5291 5.60039 13.1977 5.60039H10.2504C9.91902 5.60039 9.65039 5.33176 9.65039 5.00039C9.65039 4.66902 9.91902 4.40039 10.2504 4.40039H12.0255C11.0362 3.29501 9.59919 2.60039 8.00039 2.60039Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "refresh.fcddd28d8c20fc927973c9719a065e1d.svg";